import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Socket } from 'ngx-socket-io';
import { environment } from 'src/environments/environment';

import { AuthService } from '../login/auth.service';
import { AppState } from '../redux/app.state';
import {
  CreateManufacturerDto,
  Manufacturer,
  ManufacturerSearchDto,
  UpdateManufacturerDto,
  User
} from 'src/typings';

@Injectable({
  providedIn: 'root'
})
export class ManufacturerService {
  user: User | undefined;

  manufacturerGW = this.socket.fromEvent<any>('manufacturer_changed');

  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private store: Store<AppState>,
    private socket: Socket
  ) {
    this.store.subscribe((data) => {
      this.user = data.user.info;
    });
  }

  search(payload?: ManufacturerSearchDto) {
    return this.http.post<{ data: Manufacturer[]; length: number }>(
      `${environment.BACKEND}/manufacturer/search`,
      payload
    );
  }

  create(payload: CreateManufacturerDto) {
    return this.http.post<Manufacturer>(`${environment.BACKEND}/manufacturer/create`, payload);
  }

  update(payload: UpdateManufacturerDto) {
    return this.http.put<Manufacturer>(`${environment.BACKEND}/manufacturer/update`, payload);
  }

  delete(id: number) {
    return this.http.delete(`${environment.BACKEND}/manufacturer/${id}`);
  }
}
